import { lazy, Suspense } from 'react';
import type { AppRouter } from '../router';

// Downloaded only where it shows, so staging and production never fetch it. The `InProd`
// export renders in a production build too, which is what the dev stage runs.
const TanStackRouterDevtools = lazy(() =>
  import('@tanstack/react-router-devtools').then((devtools) => ({
    default: devtools.TanStackRouterDevtoolsInProd,
  })),
);

/**
 * The router's devtools: the matched routes, their params, search and state (D-072).
 * Its toggle sits bottom left, clear of Query's bottom right.
 */
export function RouterDevtools({ router }: { readonly router: AppRouter }) {
  return (
    <Suspense fallback={null}>
      <TanStackRouterDevtools router={router} />
    </Suspense>
  );
}
